module.exports = __webpack_public_path__ + "img/17866_L.d26a3845.png";